import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_010",
  "use": "icon-su_010-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_010\"><defs><style>#icon-su_010 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_010_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_010_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"2 9 2 17 4 17 4 13 20 13 20 17 22 17 22 9 2 9\" /><rect class=\"cls-2\" x=\"6\" y=\"3\" width=\"12\" height=\"4\" /><path class=\"cls-2\" d=\"M6,21H18V15H6Zm2-4h8v2H8Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol